import { createRouter, createWebHashHistory, useRoute } from 'vue-router'
import NotFound from '@/views/NotFound.vue';
import I18nService from '@/services/i18n.service'
import PrintOSService from '@/services/PrintOS.service';

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/Home.vue'),
  },
  {
    path: '/home/add/site',
    name: 'add-site',
    redirect: to => {
      to.query.launch = 'add-site';
      return { name: 'home', query: to.query };
    },
    include: () => { return printOS.org.v1.isPSP() || printOS.org.v1.isChannel() }
  },
  {
    path: '/home/edit/site/:siteId',
    name: 'edit-site',
    redirect: to => {
      to.query.launch = 'edit-site';
      to.query.siteId = to.params.siteId;
      return { name: 'home', query: to.query };
    },
    include: () => { return printOS.org.v1.isPSP() || printOS.org.v1.isChannel() }
  },
  {
    path: '/devices',
    name: 'devices',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '@/views/devices/Devices.vue'),
    include: () => { return printOS.org.v1.isPSP() || printOS.org.v1.isChannel() }
  },
  {
    path: '/devices/add',
    name: 'add-device',
    redirect: to => {
      to.query.launch = 'add';
      return { name: 'devices', query: to.query };
    },
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/devices/activate',
    name: 'activate-device',
    redirect: to => {
      to.query.launch = 'activate';
      return { name: 'devices', query: to.query };
    },
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/devices/job-submission',
    name: 'job-submission',
    redirect: to => {
      to.query.launch = 'job-submission';
      return { name: 'devices', query: to.query };
    },
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/agents',
    name: 'agents',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/devices/agents/Agents.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/agents/agent/:agentId',
    name: 'agent',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/devices/agents/Agent.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/users',
    name: 'users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/users/Users.vue'),
  },
  //{
  //  path: '/users/user/:userId',
  //  name: 'user',
  //  // route level code-splitting
  //  // this generates a separate chunk (about.[hash].js) for this route
  //  // which is lazy-loaded when the route is visited.
  //  component: () => import(/* webpackChunkName: "account" */ '@/views/users/User.vue'),
  //},
  {
    path: '/users/user/:userId/edit',
    name: 'edit-user',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/users/EditUserRoles.dialog.vue'),
  },
  {
    path: '/invitations',
    name: 'invitations',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/users/invitations/Invitations.vue'),
  },
  //{
  //  path: '/invitations/invite',
  //  name: 'invite-user',
  //  // route level code-splitting
  //  // this generates a separate chunk (about.[hash].js) for this route
  //  // which is lazy-loaded when the route is visited.
  //  component: () => import(/* webpackChunkName: "account" */ '@/views/users/invitations/InviteUser.vue'),
  //},
  {
    path: '/planning',
    name: 'planning',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/planning/Planning.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/schedules',
    name: 'schedules',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/planning/schedules/Schedules.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/shifts',
    name: 'shifts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/planning/shifts/Shifts.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/timeoff',
    name: 'time-off',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/planning/time-off/TimeOff.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/requests',
    name: 'requests',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/requests/Requests.vue'),
  },
  {
   path: '/requests/:requestId',
   name: 'request',
   // route level code-splitting
   // this generates a separate chunk (about.[hash].js) for this route
   // which is lazy-loaded when the route is visited.
    redirect: to => {
      to.query.id = to.params.requestId;
      return { name: 'requests', query: to.query };
    },
  },
  {
    path: '/resellers',
    name: 'resellers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/resellers/Resellers.vue'),
    include: () => { return printOS.org.v1.isPSP() }
  },
  {
    path: '/connections',
    name: 'connections',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/connections/Connections.vue'),
    include: () => { return printOS.session.v1.hasFeature('connections') }
  },
  {
    path: '/customers',
    name: 'customers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/customers/Customers.vue'),
    include: () => { return printOS.org.v1.isChannel() }
  },
  {
    path: '/indigopsps',
    name: 'indigopsps',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/indigopsps/IndigoPSPs.vue'),
    include: () => { return printOS.org.v1.isChannel() && printOS.org.v1.isIndigo() }
  },
  {
    path: '/oee',
    name: 'oee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/oee/OEE.vue'),
    include: () => { return printOS.org.v1.isPSP() && printOS.session.v1.hasFeature('oee') }
  },
  {
    path: '/oee/stations',
    name: 'oee-stations',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/oee/Stations.vue'),
    include: () => { return printOS.org.v1.isPSP() && printOS.session.v1.hasFeature('oee') }
  },
  {
    path: '/oee/user/:userId',
    name: 'oee-user',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/oee/StationUserDetails.vue'),
    include: () => { return printOS.org.v1.isPSP() && printOS.session.v1.hasFeature('oee') }
  },
  {
    path: '/history',
    name: 'history',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/history/History.vue'),
  },
  {
    path: '/enforcer',
    name: 'enforcer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account" */ '@/views/enforcer/Enforcer.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
];

let router;
let printOS;

export default class RouterService {
  initRouter() {
    window.addEventListener('app-update-locale', this.handleLocaleChanged.bind(this));
    window.addEventListener('posb-breadcrumb-clicked', this.handleBreadcrumbClicked.bind(this));
    printOS = new PrintOSService();
    router =  createRouter({
      history: createWebHashHistory(),
      routes: routes.filter(r => { return r.include instanceof Function ? r.include() : true })
    });

    router.beforeEach((to) => {
      this.fireBreadcrumbs(to);
    });

    return router;
  }

  fireBreadcrumbs(to) {
    const i18n = new I18nService();
    let breadcrumbs;
    switch(to.name) {
      case 'home':
        breadcrumbs = [
          {id: 'home',display: i18n.$t('account.View_Home')},
        ];
        break;
      case 'devices':
        breadcrumbs = [
          {id: 'devices',display: i18n.$t('account.View_Devices')},
        ];
        break;
      case 'agents':
        breadcrumbs = [
          {id: 'devices',display: i18n.$t('account.View_Devices')},
          {id: 'agents',display: i18n.$t('account.View_Agents')},
        ];
        break;
      case 'agent':
        breadcrumbs = [
          {id: 'devices',display: i18n.$t('account.View_Devices')},
          {id: 'agents',display: i18n.$t('account.View_Agents')},
          {id: 'agent',display: i18n.$t('account.Agent_Title')},
        ];
        break;
      case 'users':
        breadcrumbs = [
          {id: 'users',display: i18n.$t('account.Account_Users')},
        ];
        break;
      case 'invitations':
        breadcrumbs = [
          {id: 'users',display: i18n.$t('account.Account_Users')},
          {id: 'invitations',display: i18n.$t('account.View_Invitations')},
        ];
        break;
      case 'requests':
        breadcrumbs = [
          {id: 'requests',display: i18n.$t('account.View_Requests')},
        ];
        break;
      case 'planning':
        breadcrumbs = [
          {id: 'planning',display: i18n.$t('account.Plan_Shift_Schedule')},
        ];
        break;
      case 'schedules':
        breadcrumbs = [
          {id: 'planning',display: i18n.$t('account.Plan_Shift_Schedule')},
          {id: 'schedules',display: i18n.$t('account.Plan_Schedules')},
        ];
        break;
      case 'shifts':
        breadcrumbs = [
          {id: 'planning',display: i18n.$t('account.Plan_Shift_Schedule')},
          {id: 'shifts',display: i18n.$t('account.Plan_Shifts')},
        ];
        break;
      case 'time-off':
        breadcrumbs = [
          {id: 'planning',display: i18n.$t('account.Plan_Shift_Schedule')},
          {id: 'time-off',display: i18n.$t('account.Plan_Timeoff')},
        ];
        break;
      case 'oee':
        breadcrumbs = [
          {id: 'oee',display: i18n.$t('account.OEE')},
        ];
        break;
      case 'oee-stations':
        breadcrumbs = [
          {id: 'oee',display: i18n.$t('account.OEE')},
          {id: 'oee-stations',display: i18n.$t('account.View_Stations')},
        ];
        break;
      case 'oee-user':
        breadcrumbs = [
          {id: 'oee',display: i18n.$t('account.OEE')},
          {id: 'oee-user',display: i18n.$t('account.CheckInHistory2')},
        ];
        break;
      case 'connections':
        breadcrumbs = [
          {id: 'connections',display: i18n.$t('account.View_Connections')},
        ];
        break;
      case 'resellers':
        breadcrumbs = [
          {id: 'resellers',display: i18n.$t('account.View_Resellers')},
        ];
        break;
      case 'customers':
        breadcrumbs = [
          {id: 'channel',display: i18n.$t('account.View_Customers')},
        ];
        break;
      case 'indigopsps':
        breadcrumbs = [
          {id: 'indigopsps',display: i18n.$t('account.View_Channel_PSPs')},
        ];
        break;
      case 'history':
        breadcrumbs = [
          {id: 'history',display: i18n.$t('account.View_History')},
        ];
        break;
      case 'enforcer':
        breadcrumbs = [
          {id: 'home',display: i18n.$t('account.View_Home')},
          {id: 'enforcer',display: i18n.$t('Enforcer')},
        ];
        break;
      case 'enforcer-explain':
        breadcrumbs = [
          {id: 'home',display: i18n.$t('account.View_Home')},
          {id: 'enforcer',display: i18n.$t('Enforcer')},
          {id: 'enforcer-explain',display: i18n.$t('Details')},
        ];
        break;
    }

    window.dispatchEvent(new window.CustomEvent('posb-view-changed', {detail: { breadcrumbs }}));
  }

  handleBreadcrumbClicked(event) {
    if (!event.detail.id) {
      router.push({ name: 'home' });
      return;
    }

    router.push({ name: event.detail.id, params: event.detail.data});
  }

  handleLocaleChanged() {
    const route = router?.currentRoute?.value || null;
    if ( route ) {
      this.fireBreadcrumbs(route);
    }
  }
}

